"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayout = exports.PageLayoutState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var banner_1 = require("../components/banner/banner");
var license_banner_1 = require("../components/license.banner/license.banner");
var message_banner_1 = require("../components/message.banner/message.banner");
var modal_service_1 = require("../components/modal/modal.service");
var notification_service_1 = require("../components/notification.toast/notification.service");
var theme_1 = require("../components/theme");
var mithril_1 = require("../mithril");
var nav_drawer_1 = require("../modules/nav.drawer/nav.drawer");
var nav_drawer_ctrl_1 = require("../modules/nav.drawer/nav.drawer.ctrl");
var CSS = {
    container: 'c-Page',
    banner: 'c-Page__Banner',
    content: 'c-Page__Content',
    layout: 'c-Page__Layout',
    overlay: 'c-Page__Overlay',
    constrainWidth: 'c-Page__ConstrainWidth'
};
var Style = (_a = {},
    _a[CSS.container] = {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.font.color.primary,
        'font-family': theme_1.DefaultTheme.font.family
    },
    _a[CSS.content] = {
        flex: 1
    },
    _a['mdl-layout--fixed-drawer > .mdl-layout__content'] = {
        padding: theme_1.DefaultTheme.space(4)
    },
    // Unrestrict height for printing across multiple pages
    _a['@media print'] = (_b = {},
        _b[CSS.layout] = {
            height: 'auto',
            display: 'block'
        },
        _b[CSS.content] = {
            display: 'block'
        },
        _b),
    _a);
(0, theme_1.addStyles)(Style);
exports.PageLayoutState = {
    nav: new nav_drawer_ctrl_1.NavDrawerCtrl()
};
var PageLayout = /** @class */ (function () {
    function PageLayout() {
        if (PageLayout.banner == null) {
            PageLayout.banner = new banner_1.BannerComponent();
        }
        this.messageBanner = new message_banner_1.MessageBannerComponent();
        this.licenseBanner = new license_banner_1.LicenseBannerComponent();
    }
    PageLayout.prototype.setPage = function (page) {
        this.page = page;
    };
    PageLayout.prototype.view = function () {
        if (this.page == null) {
            return null;
        }
        var config = this.page.config;
        return (0, mithril_1.m)('div', { className: "".concat(CSS.container, " mdl-layout__container") }, [
            (0, mithril_1.m)('div', { className: "".concat(CSS.layout, " mdl-layout ").concat(config.layout.nav ? 'mdl-layout--fixed-drawer' : '') }, [
                this.messageBanner.view(),
                this.licenseBanner.view(),
                // Banner (top)
                config.layout.banner ? (0, mithril_1.m)('div', { className: CSS.banner }, PageLayout.banner.view()) : null,
                // Nav Drawer (left)
                nav_drawer_1.NavDrawer.view(exports.PageLayoutState.nav),
                // Content (center)
                (0, mithril_1.m)('div', { className: "".concat(CSS.content, " mdl-layout__content") }, this.page.view()),
                // Overlays (display over all other elements)
                (0, mithril_1.m)('div', { className: CSS.overlay }, [
                    modal_service_1.ModalService.view(),
                    notification_service_1.NotificationService.view()
                ])
            ])
        ]);
    };
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], PageLayout.prototype, "page", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PageLayout.prototype, "setPage", null);
    return PageLayout;
}());
exports.PageLayout = PageLayout;
//# sourceMappingURL=page.layout.js.map